import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
export default class MobileTabItem extends Component {
  view(vnode) {
    return m(LinkButton, {
      className: "MobileTab-item",
      href: this.attrs.href,
      icon: this.attrs.icon,
      target: this.attrs.target,
      external: this.attrs.external ?? false
    }, vnode.children);
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'forum/components/MobileTabItem', MobileTabItem);